<div class="edit-form">
  <div class="grid grid-cols-2 gap-1 mb-8 bg-white px-2">
    <div *ngFor="let field of editField" class="p-1 flex flex-col justify-start">
      <label class="font-semibold w-full flex justify-start">{{ field.label }}</label>
      <input
        *ngIf="field.type !== 'textarea'"
        type="text"
        [(ngModel)]="editFields[field.name]"
        class="border p-1 rounded-sm"
        [placeholder]="field.placeholder"
        [disabled]="!field.edit"
        [attr.aria-label]="field.label"
      />
    </div>
  </div>
  <div class="flex w-full justify-end gap-2 pr-3 mb-2">
    <button (click)="onCancel()" class="btn ml-2">Cancel</button>
    <button (click)="onUpdate()" class="btn btn-primary">Update</button>
  </div>

  <app-spinner *ngIf="isLoading"></app-spinner>
  <app-status-messages [tosterMessage]="tosterMessage"></app-status-messages>
</div>
